import { useCallback } from 'react';
import { TableWithHeader } from './shared/TableWithHeader';
import { DataTableRow } from '../../common/table/TableTypes';
import {
  DependenciesContentViewType,
  SelectedDependencyWithClearHistoryProps,
} from '../dependencies/types';
import { TableTypography } from '../../common/table/utils';
import { TableItemHighlightedText } from '../dependencies/search/highlight/TableItemHighlightedText';
import { PossibleSectionInDependencies } from '../dependencies/search/types';
import { NameProperties } from '../../parser/ParserTypes';
import { OBJECT } from '@server/parser';

const columns = [
  { field: 'label', headerName: 'Label', width: '200px' },
  { field: 'name', headerName: 'API Name' },
];

const renderRows = ({
  items,
  section = 'dependencies',
  dataTableType = OBJECT,
}: {
  items: NameProperties[];
  section?: PossibleSectionInDependencies;
  dataTableType?: string;
}) => {
  return items.map((row, index) => ({
    id: row.name,
    label: (
      <TableTypography>
        <TableItemHighlightedText
          text={row.label}
          field="label"
          section={section}
          tableType={dataTableType}
          rowIndex={index}
        />
      </TableTypography>
    ),
    name: (
      <TableTypography>
        <TableItemHighlightedText
          text={row.name}
          field="name"
          section={section}
          tableType={dataTableType}
          rowIndex={index}
        />
      </TableTypography>
    ),
    _nameStr: row.name, //needed in onRowClick
    isClickable: true,
  }));
};

interface ObjectTableProps {
  items: NameProperties[];
  onItemClick: (props: SelectedDependencyWithClearHistoryProps) => void;
  clearHistory?: boolean;
  section?: PossibleSectionInDependencies;
  dataTableType?: string;
}

export const ObjectsTable = ({
  items,
  onItemClick,
  clearHistory,
  section = 'dependencies',
  dataTableType = OBJECT,
}: ObjectTableProps) => {
  const onRowClick = useCallback(
    (e: React.MouseEvent<HTMLTableCellElement, MouseEvent>, row: DataTableRow) => {
      onItemClick({
        id: row.id,
        name: row._nameStr,
        parentType: OBJECT,
        clearHistory,
        contentType: DependenciesContentViewType.default,
      });
    },
    [onItemClick, clearHistory],
  );

  return (
    <TableWithHeader
      tableHeader="Objects"
      columns={columns}
      rows={renderRows({ items, section, dataTableType })}
      onRowClick={onRowClick}
      dataTableType={dataTableType}
      section={section}
    />
  );
};
